export default __webpack_public_path__ + "static/media/artist4.d5bc4dcc.jpg";